import * as React from 'react';

function SvgPlusSquareIcon(props) {
  return (
    <svg
      width={22}
      height={22}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.25 11.916h1.834v1.834a.917.917 0 001.833 0v-1.834h1.833a.916.916 0 100-1.833h-1.833V8.25a.916.916 0 10-1.833 0v1.833H8.25a.917.917 0 000 1.833zm11-10.083H2.75a.917.917 0 00-.917.917v16.5a.917.917 0 00.917.916h16.5a.916.916 0 00.917-.916V2.75a.916.916 0 00-.917-.917zm-.916 16.5H3.667V3.666h14.667v14.667z"
        fill="#18379A"
      />
    </svg>
  );
}

export default SvgPlusSquareIcon;
